import * as ReactDOM from "react-dom";
import * as React from "react";
import { createRoot } from "react-dom/client";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fad } from "@fortawesome/pro-duotone-svg-icons";
import "react-loading-skeleton/dist/skeleton.css";

library.add(fad);

interface Window {
    IDENTITYSERVERURL: string;
    SERVICEMANAGERURL: string;
    PRESENCEURL: string;
    IdentityClientID: string;
    IdentityServerUrl: string;
    IdentityAuthority: string;
}

import App from "./App";

import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { BrowserRouter as Router } from "react-router-dom";

import { msalConfig } from "./authConfig";
import { GetUser } from "./utils/IdentityAPI";

import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const appInsights = new ApplicationInsights({ config: {
  connectionString: 'InstrumentationKey=178c6ad6-01e9-46b2-8f15-9490d2bc22c8;IngestionEndpoint=https://uaenorth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://uaenorth.livediagnostics.monitor.azure.com/'
} });
appInsights.loadAppInsights();
appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview

export const msalInstance = new PublicClientApplication(msalConfig);

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
    if ((event.eventType === EventType.LOGIN_SUCCESS || event.eventType == EventType.ACQUIRE_TOKEN_SUCCESS) && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
    }
});

const container = document.getElementById("app");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript



root.render(
    <Router>
        <link type="text/css" href={IdentityServerUrl + "static/branding/theme"} rel="stylesheet" />
        <App pca={msalInstance} />
    </Router>
);
